module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("contents")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword"
    }
  }, [_vm._v("Foreword by Shiva Rea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("poses of the yogi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("Padmasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anjali & Namaste Mudras")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chakrasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trikonasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Siddhasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dhanurasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dandasana")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("poses of the gods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Natarajasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Virabhadrasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hanumanasana, Anjaneyasana & Virasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Halasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kurmasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garudasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simhasana")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("poses of the sages")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bharadvajasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Koundinyasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vasisthasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Astavakrasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vishvamitrasana")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("animals & earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matsyasana & Matsyendrasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chandrasana & Ardha Chandrasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bhujangasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mayurasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hamsasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tadasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vrikshasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gomukhasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bakasana")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shavasana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/after",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/authorbio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcc34e18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cont.vue
// module id = 60
// module chunks = 0